module.exports = __webpack_public_path__ + "img/ThoughtLeadershipContributor.dcf0bef9.jpg";